const cameraKey = name => String(name || "").trim().replace(/ /g, "_");
const mediaPathFrom = camera => camera?.mediaPath || camera?.streamPath || camera?.media_path || camera?.stream_path || camera?.path || "";

export const mergeMonitoringCameras = ({ cameras = [], legacy = [], streams = [], paths = [], videoBase = "", branchId = "" }) => {
  const inventory = new Map();
  cameras.forEach(camera => {
    if (!camera.name || camera.is_active === 0) return;
    inventory.set(cameraKey(camera.name), { ...camera, mediaPath: mediaPathFrom(camera) || undefined, managementSource: camera.managementSource || "saas" });
  });
  legacy.forEach(camera => {
    if (!camera.name) return;
    const key = cameraKey(camera.name);
    const current = inventory.get(key);
    inventory.set(key, current ? { ...current, legacy_id: camera.id } : {
      ...camera, id: `legacy-${camera.id}`, legacy_id: camera.id,
      display_name: camera.display_name || camera.name, source: "legacy", managementSource: "legacy",
      status: camera.status || "offline",
    });
  });
  streams.forEach(stream => {
    if (!stream.camera_id) return;
    const key = cameraKey(stream.camera_id);
    const current = inventory.get(key) || { id: `published-${key}`, name: stream.camera_id, display_name: stream.camera_id, source: "published", managementSource: "published", status: "unknown" };
    inventory.set(key, { ...current, ai: stream, mediaPath: current.mediaPath || mediaPathFrom(stream) || undefined, ai_stream_url: current.ai_stream_url || stream.ai_stream_url });
  });
  paths.forEach(path => {
    const name = typeof path === "string" ? path : path.name;
    if (!name) return;
    const key = cameraKey(name);
    const current = inventory.get(key) || { id: `published-${key}`, name, display_name: name, source: "published", managementSource: "published", status: "unknown" };
    inventory.set(key, { ...current, mediaPath: current.mediaPath || name, hls_url: `${videoBase}/${encodeURIComponent(name)}/index.m3u8` });
  });
  return [...inventory.values()]
    .filter(camera => !branchId || String(camera.branch_id) === String(branchId))
    .sort((a, b) => cameraKey(a.name).localeCompare(cameraKey(b.name), "en", { numeric: true }));
};
